
const avatar = require('../assets/images/avatar.jpg');
function TopPanel() {
	return (
		<div id="topheader">
			<header >
				<div className="inner">
					<div className="left">
						<h1>Hi! I am <strong>Shahan</strong>, a Ph.D. student
							in Human-Centered Computing at Clemson University.
						</h1>
						<p className='icon fa-envelope'>
						&nbsp;mehtabi [at] clemson [dot] edu
						</p>
					</div>
					<div className='right'>
						<img className="image avatar" src={avatar} alt="" />
					</div>
				</div>
			</header >
			<footer id="topfooter">
				<div className="inner">
					<ul className="icons iconlist">
						<li>
							<a href="https://twitter.com/shahanM" className="icon brands fa-twitter">
								<span className="label">Twitter</span>
							</a>
						</li>
						<li>
							<a href="https://github.com/ShahanM" className="icon brands fa-github">
								<span className="label">Github</span>
							</a>
						</li>
						{/* <li>
							<a href="https://www.linkedin.com/in/shahanm/" className="icon brands fa-linkedin">
								<span className="label">LinkedIn</span>
							</a>
						</li> */}
						<li>
							<a href="https://www.instagram.com/ishahanm/" className="icon brands fa-instagram">
								<span className="label">Instagram</span>
							</a>
						</li>
						<li>
							<a rel="me" href="https://hachyderm.io/@iShahanM" className="icon brands fa-mastodon">
								<span className="label">Mastodon</span>
							</a>
						</li>
						{/* <li><a href="https://medium.com/@shahanm" class="icon brands fa-medium-m"><span class="label">Instagram</span></a></li> */}
						<li>
							<a href="https://scholar.google.com/citations?hl=en&user=r2xe5DEAAAAJ" className="icon academic ai-google-scholar">
								<span className="label">Google Scholar</span>
							</a>
						</li>
						<li>
							<a href="https://www.semanticscholar.org/author/Mehtab-Iqbal/2069559779" className="icon academic ai-semantic-scholar">
								<span className="label">Semantic Scholar</span>
							</a>
						</li>
						{/* <li><a href="#" class="icon solid fa-envelope"><span class="label">Email</span></a></li> */}
					</ul>
				</div>
			</footer>
		</div >
	);
}

export default TopPanel;